import { Modal } from "@mui/material";
import React, { useCallback, useState } from "react";
import Styles from "./FileView.module.css";
import { Close } from "@mui/icons-material";
import { Document, Page } from "react-pdf";
import { ReactComponent as Download } from "../../assets/images/downloadFile.svg";
import { SuccessMessage } from "../Toast/ErrorMessage";
import { ErrorMessage } from "formik";

const FileByteView = ({ open, handleClose }) => {
  const [numPages, setNumPages] = useState(null);
  const [error, setError] = useState("");

  async function handleDownload() {
    try {
      if (open) {
        const response = await fetch(open.url);
        const blob = await response.blob();

        if (blob.size === 0) {
          return;
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${open.name}`;
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        SuccessMessage("Downloaded successfully!");
      }
    } catch (error) {
      ErrorMessage("Failed to download document.");
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="verify-popup"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.viewDocModal}`}>
        <div
          className={`display_flex_row modalHeading  ${Styles.modalHeading}`}
        >
          <div className="headingText">{open?.name}</div>

          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <div onClick={handleDownload} style={{ cursor: "pointer" }}>
              <Download />
            </div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
        </div>
        <div className={Styles.pdfContainer}>
          {open ? (
            <Document
              file={open}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              onLoadError={() => setError("Failed to load PDF.")}
              loading={<div>Loading PDF...</div>}
              error={<div>Failed to load PDF.</div>}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={Math.min(window.innerWidth * 0.8, 800)}
                  style={{ marginBottom: 24 }}
                />
              ))}
            </Document>
          ) : (
            <div className={Styles.loadingContainer}>
              <span className={Styles.loadingText}>Loading document...</span>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FileByteView;
